import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Store } from '@ngxs/store';

import {
  ReportApiResponse,
  ReportRequestParams,
} from 'src/app/common/dtos/reports.dto';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { checkDefaultChartFilters } from '../report-controller/chart-options-helper';

@Component({
  selector: 'app-proforms-quiz-summary',
  standalone: false,

  templateUrl: './proforms-quiz-summary.component.html',
  styleUrl: './proforms-quiz-summary.component.scss',
})
export class ProformsQuizSummaryComponent implements OnInit, OnChanges {
  @Input() requestParams: ReportRequestParams;

  @Input() excludeDefaultFilters = false;

  @Output() readonly apiResponseEvent = new EventEmitter<ReportApiResponse>();

  loading = true;

  params: ReportRequestParams[] = [];

  user: User;

  apiResponse: ReportApiResponse;

  average: number;

  median: number;

  range: number;

  nullAverage = false;

  nullMedian = false;

  nullRange = false;

  constructor(private apiService: APICoreService, private store: Store) {}

  ngOnInit(): void {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
    this.initializeController();
  }

  ngOnChanges(change: SimpleChanges) {
    if (
      change['requestParams'] &&
      change['requestParams'].firstChange === false
    ) {
      this.initializeController();
    }
  }

  initializeController() {
    this.params = [JSON.parse(JSON.stringify(this.requestParams))];
    this.getDashboardData();
  }

  getDashboardData(): void {
    this.loading = true;
    const params = checkDefaultChartFilters(
      this.params[this.params.length - 1],
      this.user
    );
    this.apiService
      .getRequest(
        'reporting/custom',
        this.excludeDefaultFilters ? this.requestParams : params
      )
      .subscribe((value) => {
        this.apiResponse = value;

        if (this.apiResponse.labels_average) {
          this.nullAverage = false;
          this.average = this.apiResponse.labels_average;
        } else {
          this.nullAverage = true;
        }

        if (this.apiResponse.labels_median) {
          this.nullMedian = false;
          this.median = this.apiResponse.labels_median;
        } else {
          this.nullMedian = true;
        }

        if (this.apiResponse.labels_range) {
          this.nullRange = false;
          this.range = this.apiResponse.labels_range;
        } else {
          this.nullRange = true;
        }

        this.loading = false;
      });
  }
}
